import React from "react"
import CheckboxUnchecked from "assets/icons/CheckboxUnchecked.svg"
import CheckBoxBlue from "assets/icons/Checkboxblue.svg"

const CheckBoxBlueIcon = ({ checked, ...props }) => (
  <img {...props} src={checked ? CheckBoxBlue : CheckboxUnchecked} alt="" />
)

export default CheckBoxBlueIcon
